import React, { Component } from 'react'
import './style.css'
import PeaceMenu from './PeaceMenu'
import PeaceMain from './PeaceMain'
import PeaceRelax from './PeaceRelax'
import PeaceHeal from './PeaceHeal'
import PeaceFocus from './PeaceFocus'


export default class Peace extends Component {

    state = { step : 'main' }


    componentDidMount() {

        window.scrollTo(0, 0)

    }


    stepFx = (cb) => {

        this.setState({ step : cb })

    }


    render() {

        return (

            <React.Fragment>

                <PeaceMenu menu={ this.stepFx } />

                { this.state.step === 'main' ? <PeaceMain /> : null }

                { this.state.step === 'relax' ? <PeaceRelax /> : null }

                { this.state.step === 'heal' ? <PeaceHeal /> : null }

                { this.state.step === 'focus' ? <PeaceFocus /> : null }

            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/peace/index.js